import React from "react";
import { Boxes, TrendingUp, Cog } from "lucide-react";

const CARDS = [
    {
        icon: Boxes,
        title: "Un catalogue prêt à vendre",
        text: "Recharges mobiles, eSIM voyage, gift cards, gaming, vouchers et services digitaux. Pas de stock, pas de logistique.",
    },
    {
        icon: TrendingUp,
        title: "Une commission récurrente",
        text: "Tu touches une commission sur chaque euro de volume généré par tes réseaux, chaque mois, automatiquement.",
    },
    {
        icon: Cog,
        title: "On gère tout le back-office",
        text: "Tu te concentres sur le développement commercial. CapDistrib s'occupe de la facturation, du catalogue, des flux clients et du reporting.",
    },
];

export default function WhyCapDistrib() {
    return (
        <section
            id="opportunite"
            className="relative py-24 sm:py-32 bg-cap-light overflow-hidden"
            data-testid="why-section"
        >
            <div className="absolute inset-0 bg-grid-light opacity-90 pointer-events-none" />
            <div className="absolute top-32 right-0 w-[420px] h-[420px] rounded-full bg-cap-violet/10 blur-[120px]" />

            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl">
                    <p className="fade-up eyebrow" data-testid="why-eyebrow">
                        Pourquoi CapDistrib ?
                    </p>
                    <h2
                        className="fade-up h-display text-3xl sm:text-4xl lg:text-[56px] font-bold mt-4 text-cap-ink"
                        style={{ animationDelay: "0.05s" }}
                        data-testid="why-title"
                    >
                        Une opportunité simple,
                        <br />
                        des revenus{" "}
                        <span className="text-cap-violet">récurrents</span>.
                    </h2>
                    <p
                        className="fade-up mt-6 text-lg text-cap-textMuted leading-relaxed max-w-2xl"
                        style={{ animationDelay: "0.1s" }}
                    >
                        Tu vends du temps, des contacts et une stratégie
                        commerciale. CapDistrib s'occupe du reste.
                    </p>
                </div>

                <div className="mt-16 grid md:grid-cols-3 gap-6 lg:gap-7">
                    {CARDS.map((c, i) => {
                        const Icon = c.icon;
                        const num = String(i + 1).padStart(2, "0");
                        return (
                            <div
                                key={c.title}
                                className="fade-up glass-light relative p-8 flex flex-col overflow-hidden"
                                style={{ animationDelay: `${0.08 * i + 0.1}s` }}
                                data-testid={`why-card-${i}`}
                            >
                                <span className="ghost-num ghost-num-light absolute -bottom-12 -right-2">
                                    {num}
                                </span>
                                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-cap-violet/15 to-cap-gold/10 ring-1 ring-cap-violet/20 flex items-center justify-center">
                                    <Icon className="text-cap-violet" size={26} />
                                </div>
                                <h3 className="h-display relative text-xl font-semibold text-cap-ink mt-7">
                                    {c.title}
                                </h3>
                                <p className="mt-3 text-cap-textMuted leading-relaxed relative">
                                    {c.text}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
